import { calculateOfferDuration } from '@/constants/hooks';
import { faCalendarDays, FontAwesomeIcon } from '@/constants/icons';
import React from 'react';

interface Props {
    endDate:   string | null;
    className?: string;
}

const OfferDuration = ({ endDate, className }: Props) => {
    const duration  = calculateOfferDuration(endDate);
    const isLimited = !!endDate;

    return (
        <div className={`inline-flex items-center gap-1.5 ${className || ''}`}>
            <FontAwesomeIcon
                icon={faCalendarDays}
                className={`w-3 h-3 ${isLimited ? 'text-[#D61C4E]' : 'text-slate-400'}`}
            />
            <span className="text-[10px] font-bold uppercase tracking-wider whitespace-nowrap
                             text-slate-500">
                {duration}
            </span>
        </div>
    );
};

export default OfferDuration;
